var map = {
	"./1-cts.jpg": 29677,
	"./10-tcs.webp": 86379,
	"./11-Hewlett-Packard.svg": 74058,
	"./12-tvs.jpg": 90232,
	"./13-Tech_Mahindra.png": 93805,
	"./14-Britannia.png": 82069,
	"./15-itc.png": 72248,
	"./16-Bosch.png": 26356,
	"./17-Polaris.png": 14584,
	"./18-Soliton.png": 43649,
	"./19-Hyundai.png": 32740,
	"./2-wipro.png": 95239,
	"./20-sanmar.png": 65034,
	"./21-LarsenToubro.png": 21393,
	"./22-hatsun.jpg": 37701,
	"./23-Vedanta.jpg": 76164,
	"./25-Payoda.png": 14483,
	"./25-nissan.jpg": 37939,
	"./26-sirius.png": 39285,
	"./27-Vernalis.jpg": 16969,
	"./29-anristu.webp": 77977,
	"./3-infosys.jpg": 15380,
	"./30-kalycito.png": 60051,
	"./31-fanuc.jpg": 14007,
	"./31-urc.svg": 18292,
	"./34-vuram.png": 25532,
	"./35-rane.jpg": 7450,
	"./36-sakthi.png": 69359,
	"./37-brakes.png": 55800,
	"./38-delphi.png": 26961,
	"./39-kbr.png": 84155,
	"./4-accenture.jpg": 70208,
	"./40-airlight.png": 50870,
	"./41-Trimble.png": 8654,
	"./42-pentafox.png": 96663,
	"./43-josh.jpg": 81475,
	"./44-Rapid_Data.png": 65671,
	"./45-blubridge.jpeg": 81562,
	"./46-valeo.png": 61091,
	"./47-Bi3-Logo.png": 49961,
	"./48-CDW Sirius.png": 36073,
	"./49-codemagen_logo.jpeg": 66289,
	"./5-zoho.png": 50815,
	"./50-jman.jpeg": 16394,
	"./51.Securin.svg": 82776,
	"./53-Rubrik.png": 92949,
	"./6-Huawei-Logo.png": 77179,
	"./7-newge.png": 26829,
	"./8-Mu-sigma.png": 14054,
	"./9-ELGi.png": 63998,
	"./Adrasti logo (1).jpeg": 7599,
	"./ERP Roots Logo (1).jpeg": 21517,
	"./Endava Solutions logo.png": 30071,
	"./Green Collar Agritech Solutions Pvt. Ltd. Logo.png": 80473,
	"./IamNeo.ai logo.png": 20993,
	"./Ignitarium logo.png": 83999,
	"./J&F India Pvt. Ltd..jpeg": 76943,
	"./JPMorgan Chase (1).png": 52065,
	"./Openmynz - Logo.png": 23511,
	"./Presidio logo.jpeg": 27430,
	"./Radiant global technology logo.png": 21910,
	"./SKM Groups logo.jpg": 13841,
	"./SRC Projects.jpeg": 6844,
	"./Schneider Electric Logo (1).jpeg": 69085,
	"./WhatsApp Image 2025-09-15 at 11.27.31 AM.jpeg": 98491,
	"./WhatsApp Image 2025-09-15 at 11.28.18 AM.jpeg": 47273,
	"./WhatsApp Image 2025-09-15 at 11.35.49 AM.jpeg": 65777,
	"./WhatsApp Image 2025-09-15 at 11.45.14 AM.jpeg": 45684,
	"./WhatsApp Image 2025-09-15 at 11.45.57 AM.jpeg": 67020,
	"./WhatsApp Image 2025-09-15 at 11.55.18 AM.jpeg": 53509,
	"./WhatsApp Image 2025-09-16 at 1.43.24 PM.jpeg": 86784,
	"./WhatsApp Image 2025-09-16 at 1.43.48 PM.jpeg": 86170,
	"./WhatsApp Image 2025-09-16 at 2.21.06 PM.jpeg": 71459,
	"./WhatsApp Image 2025-10-09 at 11.26.43 AM.jpeg": 13542,
	"./WhatsApp Image 2025-10-09 at 11.42.54 AM.jpeg": 46676,
	"./coreEL Technologies logo..jpeg": 43095,
	"./hitech calibration logo.jpeg": 25646,
	"./nbase2 logo (1).png": 4179,
	"./workhall logo.png": 74888
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24211;